import { css } from 'linaria';

export const text = css`
  color: var(--lct-color);
`;
